import { render, staticRenderFns } from "./OrderItemSplit.vue?vue&type=template&id=0a976c28&scoped=true"
import script from "./OrderItemSplit.vue?vue&type=script&lang=js"
export * from "./OrderItemSplit.vue?vue&type=script&lang=js"
import style0 from "./OrderItemSplit.vue?vue&type=style&index=0&id=0a976c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a976c28",
  null
  
)

export default component.exports